import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  IMessagesService,
  MESSAGES_SERVICE,
} from '../../services/IMessages.service';
import * as fromGbmActions from '../actions/gbmConversations.actions';
import { GbmConversationsStore } from '../store/gbmConversations.store';

@Injectable()
export class GbmConversationsEffects {
  loadConversations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGbmActions.GbmActionTypes.getGbmConversationsBegin),
      switchMap((action: any) =>
        this.service.getGBMConversationList().pipe(
          map((payload) =>
            fromGbmActions.getGbmConversationsSuccessAction({ payload })
          ),
          catchError((error) => {
            console.error('Could not get messages', error);
            return of(
              fromGbmActions.getGbmConversationsFailAction({ errors: error })
            );
          })
        )
      )
    )
  );

  loadConversationMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGbmActions.getGbmConversationMessagesBeginAction),
      switchMap((action) =>
        this.service.getGBMMessageList(action.payload).pipe(
          map((data) =>
            fromGbmActions.getGbmConversationMessagesSuccessAction({
              payload: data.messages,
            })
          ),
          catchError((error) => {
            console.error('Could not get conversation messages', error);
            return of(
              fromGbmActions.getGbmConversationMessagesFailAction({
                errors: error,
              })
            );
          })
        )
      )
    )
  );

  replyToConversationMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromGbmActions.replyGbmConversationMessageBeginAction),
      withLatestFrom(this.gbmStore.messagesData$),
      switchMap(([action, lastData]) =>
        this.service
          .replyGBMMessage(action.conversationId, action.message)
          .pipe(
            map((updatedMessage) => 
              fromGbmActions.replyGbmConversationMessageSuccessAction({
                payload: [...lastData, updatedMessage],
              })
            ),
            catchError((error) => {
              console.error('Could not reply conversation messages', error);
              return of(
                fromGbmActions.replyGbmConversationMessageFailAction({
                  errors: error,
                })
              );
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private gbmStore: GbmConversationsStore,
    @Inject(MESSAGES_SERVICE) private service: IMessagesService
  ) {}
}
